import React, { memo } from "react";
import Grid from "@mui/material/Grid";
import { DashboardSubTypography } from "@assets/Typography";
import { DefaultAvatar } from "@assets/avatar";
import { IncCalender02 } from "@assets/imglink";
import images from "@app/images";
import FormLabel from "./FormLabel";
import DashboardDatePicker from "./DashboardDatePicker";

const DashboardHeaderRight = memo(
  ({
    label,
    check,
    handleChecked,
    dates,
    op,
    handleChangeDate,
    setOp,
    openEnd,
    setOpenEnd,
  }) => {
    return (
      <>
        <DefaultAvatar
          alt="캘린더아이콘2"
          src={IncCalender02}
          width={80}
          height={80}
        />
        <Grid sx={{ pl: 2.5, flexGrow: 1, pr: 5.5 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <DashboardSubTypography text={"기간을 설정해 주세요"} />
            <FormLabel label={label} check={check} onChange={handleChecked} />
          </Grid>
          <Grid container sx={{ mt: 1 }}>
            <Grid
              container
              justifyContent="space-around"
              alignItems="center"
              sx={{
                flexGrow: 1,
                height: 42,
                pl: 1.5,
                pr: 1.5,
                bgcolor: "grey.400",
                borderRadius: "10px",
              }}
            >
              <DashboardDatePicker
                dates={dates}
                dateCase="start"
                openEnd={openEnd}
                op={op}
                setOpenEnd={setOpenEnd}
                setOp={setOp}
                handleChangeDate={handleChangeDate}
              />
              <img src={images.icn_arrowLeft.default} alt=">" />
              <DashboardDatePicker
                dates={dates}
                dateCase="end"
                openEnd={openEnd}
                op={op}
                setOpenEnd={setOpenEnd}
                setOp={setOp}
                handleChangeDate={handleChangeDate}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
);

export default DashboardHeaderRight;
